import React, { useEffect, useReducer, useRef, Fragment } from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import Search from '../search/search';
import PropTypes from 'prop-types';
import { VALID_ADDRESS_FIELDS, getAddressData } from '../../utils/templates/address';
import { change, Field, untouch } from 'redux-form';
import { connect } from 'react-redux';
import { DETAIL_HANDLER, normalizeSG, SUGGESTION_HANDLER } from './hooks';
import { resetFields, checkAllEmptyArrayValues } from '../../utils/library';
import {
  ADDRESS_NOT_FOUND_MSG,
  EU_EXCEPTIONS_COUNTRIES,
  EU_REGION,
  UtilityContentMsg
} from '../../utils/constants';
import { required } from '../../utils/validation/index';
import { API_URL } from '../../utils/config';
import { setAddressInfo, setAddressError } from '../../redux/actions/user-state/user-state-action';
import {
  setShowSearchBoxVisibilty,
  resetSearchBoxDetails,
  setRequiredFields,
  setSearchText
} from '../../redux/actions/common/common-action';
import './address-block.scss';
import isEqual from 'lodash/isEqual';
import styled from 'styled-components';
import BoxDropdown from '../../components/form-controls/outlinedDropdown';
import OutlinedTextFields from '../material-textField';
import isEmpty from 'lodash/isEmpty';
import COLORS from '../../common/styles/color-pallete';
import { Col, Row } from '../../screens/nium-forex/styles';
import { RECIPIENT_SCREEN } from '../../screens/nium-forex/utils/constants';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { INFO_GREY_ICON } from '@Images';

const SectionHead = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  margin-top: 40px;
  padding-bottom: 5px;
  margin-left: ${(props) => (props.countryCode === 'IN' ? '0px' : '10px')};
  @media only screen and (max-width: 1080px) {
    margin-top: ${(props) => props.countryCode === 'IN' && '15px'};
  }
  P {
    font-size: ${(props) => props.countryCode === 'IN' && '20px'};
  }
  .trans {
    display: flex;
    @media only screen and (min-width: 500px) and (max-width: 1080px) {
      justify-content: ${(p) => (p.formName === 'PersonalDetails' ? 'flex-start' : 'center')};
    }
  }
  .UtilityContent {
    font-family: 'hellix-regular';
    font-size: 12px;
    font-weight: normal;
    letter-spacing: normal;
    color: ${COLORS.textLightGrey};
    margin-top: 5px;
  }
`;

export const AddressWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${COLORS.black};
    margin-top: 23px;
  }

  .addressContent {
    object-fit: contain;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.83;
    letter-spacing: normal;
    text-align: center;
    color: #1a1a1a;
    margin: 23px 0px 20px 0px;
    width: 85%;
  }
`;
export const Modal = styled.div`
  position: absolute;
  height: 270vh;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 11;
  background-color: rgba(255, 255, 255, 0.8);

  .modalBox {
    position: absolute;
    margin-left: 6%;
    top: 503px;
    width: 90%;
    height: 351px;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #f7f7f7;
    background-color: ${COLORS.white};

    .addressWrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .crossButton {
        font-size: 20px;
        color: #00c1ff;
        width: 100%;
        font-family: ${FONT_FAMILY.hellix.regular};
        display: flex;
        justify-content: flex-end;
        margin-right: 15px;
        margin-bottom: 36px;
        margin-top: 19px;
        button {
          background-color: transparent;
          border: none;
          color: #00c1ff;
        }
      }

      .title {
        font-family: ${FONT_FAMILY.hellix.bold};
        font-size: 16px;
        font-weight: 900;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: ${COLORS.black};
        margin-top: 23px;
      }

      .addressContent {
        object-fit: contain;
        font-family: ${FONT_FAMILY.hellix.regular};
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.83;
        letter-spacing: normal;
        text-align: center;
        color: #1a1a1a;
        margin: 23px 0px 20px 0px;
        width: 85%;
      }

      .closeButton {
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.67;
        letter-spacing: 0.64px;
        text-align: center;
        color: #354087;
        margin-top: 10px;
        button {
          color: #354087;
          background-color: transparent;
          border: none;
          text-decoration: underline #00c1ff;
        }
      }
    }
  }
`;

const AddressFieldInnerBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  .innerFields {
    max-width: 325px !important;
    z-index: 1;
    @media only screen and (max-width: 1080px) {
      width: 325px;
    }
  }
  @media only screen and (max-width: 1080px) {
    align-items: center;
    margin: 0px;
  }
`;
const AddressFields = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;

  div > div > div {
    @media only screen and (min-width: 1080px) {
      margin-left: 0px;
    }
  }

  .addressBlockInnerFields {
    width: 33%;
    z-index: 0;
    margin-bottom: 8px;
    &:has(#error-msg:not(:empty)) {
      margin-bottom: 24px;
    }
    @media only screen and (max-width: 1080px) {
      width: 339px;
      margin-bottom: 0px;
      &:has(#error-msg:not(:empty)) {
        margin-bottom: 0px;
      }
    }
  }
  @media only screen and (max-width: 1080px) {
    flex-direction: column;
    align-items: center;
  }
`;
const reducer = (state, action) => ({ ...state, ...action });

function AddressBlock(props) {
  const { isSsnBackNavigatedFlag } = props;
  const [state, setState] = useReducer(reducer, {
    suggestions: [],
    fields: [],
    totalPages: 1,
    page: 1,
    requiredFieldName: [],
    loading: false,
    disable_fields: true,
    showMessage: false,
    width: 0,
    height: 0,
    showFields: !(
      !EU_REGION.includes(props.countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(props.countryCode)
    ),
    selectedData: ''
  });
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, []);

  useEffect(() => {
    const { showFields, selectedData } = state;
    //clearding data when user toggle from auto search to manual input
    if (!showFields && !isEmpty(selectedData)) {
      setState({ selectedData: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.showFields]);

  useEffect(() => {
    const { countryCode, dispatch } = props;
    dispatch(resetSearchBoxDetails());
    const showSearchBox =
      !EU_REGION.includes(countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(countryCode);
    dispatch(setShowSearchBoxVisibilty(showSearchBox));
    setState({
      fields: getAddressData(props.addressConfig)
    });
    /**
     * find all validate required state and check
     * for there redux value if its not null then
     * send a true flag to **not show** 'Please enter valid address '
     * this message else need to show this message
     */

    const requiredFields = state.fields.filter(
      (item) => item.validate && item.validate.includes(required)
    );
    const requiredFieldName = requiredFields.map((f) => f.field);

    props.dispatch(setRequiredFields(requiredFieldName));

    const { getAllformVal } = props;
    if (getAllformVal) {
      const reqAddrFields = Object.keys(VALID_ADDRESS_FIELDS);
      Object.keys(getAllformVal).forEach((x) => {
        if (!state.showFields && reqAddrFields.includes(x) && getAllformVal[x]) {
          setState({ showFields: true });
        }
      });
    }
    return () => {
      props.dispatch(setAddressError(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { getAllformVal, formSectionName } = props;
    /**
     * check for change in value for address.
     * Also check for corporate address by form section
     *
     */

    if (!isEqual(prevFields.current, getAllformVal)) {
      const reqAddrFields = Object.keys(VALID_ADDRESS_FIELDS);

      // to check if address in business and incorporation has all empty string
      const formSectionValues =
        formSectionName &&
        getAllformVal &&
        getAllformVal[formSectionName] &&
        Object.values(getAllformVal[formSectionName]);
      const isFormSectionAllEmpty = checkAllEmptyArrayValues(formSectionValues);
      getAllformVal &&
        Object.keys(getAllformVal).forEach((x) => {
          if (!state.showFields && reqAddrFields.includes(x) && getAllformVal[x]) {
            /**if corp && formSection empty hide form fields else show fields */
            if (formSectionName && getAllformVal[formSectionName] && isFormSectionAllEmpty) {
              setState({ showFields: false });
            } else {
              setState({ showFields: true });
            }
          }
        });
    }
  });
  const prevFields = useRef;

  useEffect(() => {
    const { getAllformVal } = props;
    prevFields.current = getAllformVal;
  });

  useEffect(() => {
    if (props.countryCode) {
      state.fields.forEach(({ field }) => props.dispatch(change(props.formName, field, '')));
    }

    setState({
      fields: getAddressData(props.addressConfig),
      suggestions: [],
      selectedData: {}
    });
    setSearch && setSearch('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countryCode]);

  useEffect(() => {
    setState({
      fields: getAddressData(props.addressConfig)
    });
  }, [props.addressConfig]);

  useEffect(() => {
    /**if search node is mount and (textFieldRef || dropdownRef ) is not mount the show error on submit */
    const searchAddressFieldNotSelected =
      searchRef.current && !(textFieldRef.current || dropdownRef.current);
    if (searchAddressFieldNotSelected) {
      props.dispatch(setAddressError('Please select address from search'));
    } else {
      props.dispatch(setAddressError(null));
    }
  });

  let setSearch = '';
  const searchRef = useRef(null);
  const dropdownRef = useRef(null);
  const textFieldRef = useRef(null);

  useEffect(() => {
    const searchAddressFieldNotSelected =
      searchRef.current && (textFieldRef.current || dropdownRef.current);
    if (searchAddressFieldNotSelected) {
      props.dispatch(setAddressError(null));
    }
  });

  /**reset form fields to null */
  const resetFormFields = (fields, dispatch) => {
    const fieldObj = fields.reduce((acc, res) => {
      acc[res.field] = '';
      return acc;
    }, {});
    resetFields(
      props.formName,
      fieldObj,
      dispatch,
      change,
      untouch,
      props.formSectionName ? props.formSectionName : null
    );
  };

  const onSearchChangeGenerator = (country_code) => {
    const { dispatch } = props;

    const { [country_code]: handler = SUGGESTION_HANDLER.default } = SUGGESTION_HANDLER;
    return async (keyword = '', page, refresh = true, search_id) => {
      resetFormFields(state.fields, dispatch);
      await setState({ loading: true, showFields: false });
      const params = {
        keyword,
        country_code,
        page: refresh ? 1 : page
      };
      if (search_id) params.search_id = search_id;
      const result = await handler(params, !refresh && state.suggestions);
      if (result) {
        // dispatch and store disabled_fields in redux
        const { disable_fields } = result;
        const { dispatch } = props;
        dispatch(
          setAddressInfo({
            disable_fields
          })
        );
      }
      await setState({
        loading: false,
        disable_fields: (result && result.disable_fields) || false,
        showMessage: (result && !result.disable_fields) || false,
        ...(result || (result === undefined ? { suggestions: [] } : {}))
      });
    };
  };
  const toggleShowFields = (value) => {
    if (value) {
      setState({ showFields: value });
      setState({ dontDisable: true }); /** don't disable if manullay open */
    } else {
      setState({ showFields: false });
    }
    resetFormFields(state.fields, props.dispatch);
  };
  const onSuggestionSelectedGenerator = (country_code) => {
    return async (optn) => {
      const { value, Id: placeId } = optn;
      // eslint-disable-next-line
      if (typeof placeId == 'string' ? !placeId : value < 0 || value >= state.suggestions.length)
        return;
      setState({ loading: true });
      const data = await DETAIL_HANDLER[country_code](
        {
          placeId: value,
          country_code
        },
        state.suggestions
      );
      if (data) {
        const { fields } = state;
        const { formName, formSectionName, dispatch } = props;
        await fields.forEach(({ field }) =>
          dispatch(
            change(
              formName,
              formSectionName ? `${formSectionName}.${field}` : field,
              field === 'street'
                ? data['street_name'] || data['street_type']
                  ? (data['street_name'] || '') + ' ' + (data['street_type'] || '')
                  : ''
                : data[field]
            )
          )
        );
      }
      await setState({
        loading: false,
        keepOpen: false,
        selectedData: data,
        showFields: true
      });
    };
  };

  const isDisabled = (field, shouldDisable, disable_fields, countryCode) => {
    // early return as selectedData doesnt gets updated in case of IN
    if (countryCode === 'IN') {
      // eslint-disable-next-line no-prototype-builtins
      const responseOfDisabled = field.hasOwnProperty('editable')
        ? disable_fields
          ? !field.editable
          : false
        : false;
      return responseOfDisabled || props.isDocsUploadedOrEVerifiedSuccess || shouldDisable;
    }
    const currentField = field.field;
    const { selectedData } = state;
    if (!isEmpty(selectedData)) {
      if (currentField === 'street' && !selectedData.street_name && !selectedData.street_type) {
        return false;
      } else if (currentField !== 'street' && !selectedData[currentField]) {
        //street
        return false;
      }
    }

    /**
     * Commented by Krunal
     * if (getAllformVal &&
      Object.keys(getAllformVal).includes(currentField) &&
      !getAllformVal[currentField]) {
      return false;
      }
     */

    // eslint-disable-next-line no-prototype-builtins
    let responseOfDisabled = field.hasOwnProperty('editable')
      ? disable_fields
        ? !field.editable
        : false
      : false;
    // on entering address manully
    // hardcoding field disable as false
    // not using value from BE addressConfig due to requirement
    if (isEmpty(selectedData)) responseOfDisabled = false;
    return responseOfDisabled || props.isDocsUploadedOrEVerifiedSuccess || shouldDisable;
  };

  const {
    countryCode,
    sectionHead,
    isDocsUploadedOrEVerifiedSuccess,
    renderCountryOfResidence,
    disabledFields,
    getAllformVal,
    mailingAddress
  } = props;
  const { totalPages, page, suggestions, loading, disable_fields, showMessage } = state;
  const addressPopUpCheck = state.width < 1080 && props.formName === 'PersonalDetails';

  let shouldDisable = false;
  if (disabledFields) {
    const check = props.formName === 'PersonalDetails' ? true : state && !state.dontDisable;
    shouldDisable = check && state.fields && state.fields.find((k) => k && disabledFields[k.field]);
  }

  const onSearchChange = (args) => {
    setState({ showFields: false });
    args && onSearchChangeGenerator(countryCode)(args);
  };

  const updateWindowDimensions = () => {
    setState({ width: window.innerWidth, height: window.innerHeight });
  };

  const sectionHeadWithPopup = (
    <>
      <p>{sectionHead} </p>
      <Popup
        trigger={
          <img
            src={INFO_GREY_ICON}
            alt="info-icon"
            className="info-icon"
            height="20"
            width="20"
            style={{ marginLeft: '5px' }}
          />
        }
        position="left"
        content={
          <div
            style={{
              fontFamily: 'hellix-regular',
              fontSize: '12px',
              fontWeight: 'normal',
              color: COLORS.textLightGrey,
              letterSpacing: '1',
              lineHeight: '1.7'
            }}
          >
            Address search bar will define your postal code as per your search for location of
            resident.
          </div>
        }
        size="tiny"
      />
    </>
  );
  const { isNiumForexUser } = props;

  const getPostalCodePlaceHolder = () => {
    let message;
    if (countryCode === 'SG') message = 'Search with your postal code';
    else if (EU_EXCEPTIONS_COUNTRIES.includes(countryCode))
      message = 'Start typing address/postal code here';
    else if (['US'].includes(countryCode)) message = 'Start searching with street number';
    else message = 'Start typing address here';
    return message;
  };

  const onCountryOfResidenceChange = async (countryObj) => {
    const { value } = countryObj;
    props.dispatch(setSearchText(''));
    await setState({ showFields: false, showMessage: false });
    const showSearchBox = !EU_REGION.includes(value) || EU_EXCEPTIONS_COUNTRIES.includes(value);
    const _showFields = !showSearchBox ? true : false;
    props.dispatch(setShowSearchBoxVisibilty(showSearchBox));
    await setState({ showFields: _showFields });
  };

  const getAddressHeading = () => {
    let result;
    if (sectionHead) {
      if (addressPopUpCheck) {
        result = sectionHeadWithPopup;
      } else {
        result = sectionHead;
      }
    } else if (countryCode === 'MY') {
      if (mailingAddress) {
        result = 'Mailing address';
      } else {
        result = 'Residential address new';
      }
    } else {
      result = 'Address';
    }
    return result;
  };

  return (
    <Grid.Row className="form-row" id="address-block">
      {!isNiumForexUser && (
        <Grid.Column className="payee-details-column" width={16}>
          <SectionHead formName={props && props.formName} countryCode={countryCode}>
            <div id="Address_heading" className="trans">
              {getAddressHeading()}
            </div>
            {!isDocsUploadedOrEVerifiedSuccess && (
              <p className="UtilityContent">{UtilityContentMsg}</p>
            )}
          </SectionHead>
        </Grid.Column>
      )}
      {renderCountryOfResidence && props.account_type !== 'CORPORATE' && (
        <>
          {isNiumForexUser ? (
            <Row padding={[16, 0]}>
              <Col width={450}>
                <Field
                  bindToThisObject={countryCode}
                  name="country_code"
                  type="text"
                  component={BoxDropdown}
                  width="100%"
                  placeholder={RECIPIENT_SCREEN.addRecipient.countryOfResidence}
                  validate={[required]}
                  onDropdownChange={onCountryOfResidenceChange}
                  url={`${API_URL}/beneficiary/countries/dropdown`}
                />
              </Col>
            </Row>
          ) : (
            <AddressFieldInnerBox>
              <div className="innerFields">
                <Field
                  bindToThisObject={countryCode}
                  name="country_code"
                  type="text"
                  component={BoxDropdown}
                  width="100%"
                  placeholder="Country of residence"
                  selectOnClose={true}
                  validate={[required]}
                  className="theme-dropdown"
                  onDropdownChange={onCountryOfResidenceChange}
                  url={`${API_URL}/countries/dropdown`}
                />
              </div>
            </AddressFieldInnerBox>
          )}
        </>
      )}
      {countryCode && (
        <Fragment>
          <Grid.Column width={16}>
            {(!EU_REGION.includes(countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(countryCode)) &&
              !(isDocsUploadedOrEVerifiedSuccess || shouldDisable) && (
                <Search
                  boxInputSearchNewUi={props?.boxInputSearchNewUi}
                  toggleShowFields={toggleShowFields}
                  showFields={state.showFields}
                  ref={searchRef}
                  placeholder={getPostalCodePlaceHolder()}
                  countryCode={props.countryCode}
                  disabled={
                    !countryCode ||
                    isDocsUploadedOrEVerifiedSuccess ||
                    shouldDisable ||
                    isSsnBackNavigatedFlag
                  }
                  onSearchChange={onSearchChange}
                  onSuggestionSelect={(...arg) => {
                    onSuggestionSelectedGenerator(countryCode)(...arg);
                  }}
                  suggestions={suggestions}
                  totalPages={totalPages}
                  page={page}
                  renderSuggestion={({ key, title }) => (
                    <div className="suggestion" key={key}>
                      {title}
                    </div>
                  )}
                  setSearchValueProvider={(func) =>
                    (setSearch = function (value) {
                      setState({ totalPages: 1, page: 1 });
                      func(value);
                    })
                  }
                  keepOpen={state.keepOpen}
                  onBlur={() => setState({ loading: false })}
                  loading={loading}
                  normalization={countryCode === 'SG' ? normalizeSG : null}
                />
              )}
          </Grid.Column>
          {showMessage && !isNiumForexUser && (
            <div style={{ padding: '1rem', color: 'red' }}>{ADDRESS_NOT_FOUND_MSG}</div>
          )}
          {showMessage && isNiumForexUser && (
            <Row padding={[13, 0]}>
              <Col width={450}>
                <div className="addressErrorMsg">{ADDRESS_NOT_FOUND_MSG}</div>
              </Col>
            </Row>
          )}
          {isNiumForexUser ? (
            <Fragment>
              {state.showMessage || state.showFields
                ? state.fields.map((field, _key) => {
                    if (!field.visible) {
                      return null;
                    }
                    switch (field.type) {
                      case 'text': {
                        return (
                          <Row padding={[13, 0]}>
                            <Col width={450}>
                              <Field
                                ref={textFieldRef}
                                name={field.field}
                                type="text"
                                parentClassName="form-text-field"
                                maxWidth="450px"
                                disableUnderlineStyling={true}
                                showLabel={true}
                                component={OutlinedTextFields}
                                validate={shouldDisable ? null : field.validate}
                                normalize={field.normalize}
                                mobiletooltip={true}
                                placeholder={field.placeholder}
                                disabled={
                                  isDisabled(field, shouldDisable, disable_fields, countryCode) ||
                                  isSsnBackNavigatedFlag
                                }
                                tooltip={
                                  getAllformVal && !getAllformVal[field.field] && field.tooltip
                                }
                                shrink={true}
                              />
                            </Col>
                          </Row>
                        );
                      }
                      case 'dropdown': {
                        return (
                          <Row padding={[13, 0]}>
                            <Col width={450}>
                              <Field
                                bindToThisObject={getAllformVal ? getAllformVal[field.field] : null}
                                name={field.field}
                                type="text"
                                ref={dropdownRef}
                                component={BoxDropdown}
                                width="100%"
                                className="theme-dropdown"
                                url={`${field.url}`}
                                validate={shouldDisable ? null : field.validate}
                                normalize={field.normalize}
                                placeholder={field.placeholder}
                                disabled={
                                  isDisabled(field, shouldDisable, disable_fields, countryCode) ||
                                  isSsnBackNavigatedFlag
                                }
                              />
                            </Col>
                          </Row>
                        );
                      }
                      default:
                        return null;
                    }
                  })
                : null}
            </Fragment>
          ) : (
            <AddressFields >
              {state.showMessage || state.showFields
                ? state.fields.map((field, key) => {
                    if (!field.visible) {
                      return null;
                    }
                    switch (field.type) {
                      case 'text': {
                        return (
                          <div className="addressBlockInnerFields">
                            <Field
                              ref={textFieldRef}
                              name={field.field}
                              type="text"
                              className="input form-flow"
                              component={OutlinedTextFields}
                              validate={shouldDisable ? null : field.validate}
                              normalize={field.normalize}
                              mobiletooltip={true}
                              placeholder={field.placeholder}
                              disabled={
                                isDisabled(field, shouldDisable, disable_fields, countryCode) ||
                                isSsnBackNavigatedFlag
                              }
                              tooltip={
                                getAllformVal && !getAllformVal[field.field] && field.tooltip
                              }
                            />
                          </div>
                        );
                      }
                      case 'dropdown': {
                        return (
                          <Grid.Column computer={7} tablet={8} mobile={16} key={key}>
                            <Field
                              bindToThisObject={getAllformVal ? getAllformVal[field.field] : null}
                              name={field.field}
                              type="text"
                              ref={dropdownRef}
                              component={BoxDropdown}
                              width="100%"
                              className="theme-dropdown"
                              url={`${field.url}`}
                              validate={shouldDisable ? null : field.validate}
                              normalize={field.normalize}
                              placeholder={field.placeholder}
                              disabled={
                                isDisabled(field, shouldDisable, disable_fields, countryCode) ||
                                isSsnBackNavigatedFlag
                              }
                            />
                          </Grid.Column>
                        );
                      }
                      default:
                        return null;
                    }
                  })
                : null}
            </AddressFields>
          )}
        </Fragment>
      )}
    </Grid.Row>
  );
}

AddressBlock.propTypes = {
  transactionDetails: PropTypes.object,
  getAllformVal: PropTypes.any,
  isDocsUploadedOrEVerifiedSuccess: PropTypes.bool,
  countryCode: PropTypes.any,
  parent: PropTypes.any,
  sectionHead: PropTypes.string,
  formSectionName: PropTypes.string,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  countryCodeUrl: PropTypes.string,
  renderCountryOfResidence: PropTypes.bool,
  disabledFields: PropTypes.any,
  addressField: PropTypes.array,
  addressConfig: PropTypes.any,
  account_type: PropTypes.string,
  mailingAddress: PropTypes.bool,
  isNiumForexUser: PropTypes.bool,
  boxInputSearchNewUi: PropTypes.bool,
  isSsnBackNavigatedFlag: PropTypes.bool
};

export default connect(null, (dispatch) => ({ dispatch }))(AddressBlock);
